import styled, { css } from 'styled-components';
import { OverlineStyles } from '../../../typography';
import { OVERLINE_LINE_HEIGHT_MULTIPLIER } from '../../../typography/overline';
import { Z_INDEXES } from '../../../../../src/styled/global-variables';
import { getColor, getColorShade, getElevation, getSizeBy } from '../../../../../src/styled/utils';
import { Tooltip } from '../../../tooltip';
const selectionCSS = css `
  width: 1%;
  white-space: nowrap;
`;
const HEAD_CELL_VERTICAL_PADDING_MULTIPLIER = 4;
const headCellHeightMultiplier = OVERLINE_LINE_HEIGHT_MULTIPLIER + HEAD_CELL_VERTICAL_PADDING_MULTIPLIER * 2;
export const zIndexCSS = css `
  z-index: ${Z_INDEXES.TABLE_HEADER};
`;
export const StyledHeadCell = styled.th `
  ${OverlineStyles};
  position: sticky;
  top: ${({ $lineIndex }) => getSizeBy(headCellHeightMultiplier * $lineIndex)};
  z-index: ${({ $isPinned }) => Z_INDEXES.TABLE_HEADER + ($isPinned ? 1 : 0)};
  padding: ${getSizeBy(HEAD_CELL_VERTICAL_PADDING_MULTIPLIER)} ${getSizeBy(2)};
  color: ${({ $isSorted, $hasTooltip }) => getColorShade($hasTooltip && $isSorted ? 'primary' : 'onSurface', $isSorted ? 'highEmphasis' : 'mediumEmphasis')};
  white-space: nowrap;
  text-align: start;
  vertical-align: middle;
  background-color: ${getColor('surface')};
  box-shadow: inset 0 -1px 0 ${getColorShade('onSurface', 'border')};
  ${({ $isSelection }) => $isSelection && selectionCSS}

  &:hover {
    color: ${({ $shouldSort, $hasTooltip }) => $hasTooltip
    ? getColorShade('primary', 'highEmphasis')
    : $shouldSort && getColorShade('onSurface', 'highEmphasis')};
  }

  &:first-child {
    padding-left: ${getSizeBy(4)};
  }

  &:last-child {
    padding-right: ${getSizeBy(4)};
  }

  &.money > span {
    justify-content: flex-end;
  }

  &.money-with-padding > span {
    justify-content: flex-end;
    padding-right: 40%;
  }

  &.group-header > span {
    justify-content: center;
  }
`;
export const StyledHeadCellTitleWrapper = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: ${({ $headerEndAlight }) => $headerEndAlight && 'flex-end'};
  width: 100%;
`;
export const StyledHeadCellTitle = styled.span `
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: ${({ $interactive }) => $interactive && 'pointer'};
`;
export const StyledTooltip = styled(Tooltip) `
  box-shadow: ${getElevation(8)};

  & div {
    max-width: ${getSizeBy(47.5)};
    color: ${getColorShade('onSurface', 'highEmphasis')};
    background-color: ${getColor('surface')};
  }
`;
